import React from "react";
import { Col, Row } from "react-bootstrap";

import './header.css';
import { Link } from "react-router-dom";

export default function Header() {
    const username: string | null = JSON.parse(localStorage.getItem('userData') ?? "null")?.username;

    return (
        <Row className="header" style={{ zIndex: 1000 }}>
            <Col className="siteName">
                <a href="/home">
                    <h1>
                        Spellslinger
                    </h1>
                </a>
            </Col>
            {username &&
                [
                    <Col className="d-none d-md-block" style={{ flex: 1 }} key={1}>
                    </Col>,
                    <Col className="d-flex align-items-center justify-content-end" xs="auto" key={2}>
                        <span className="me-2">{username}</span>
                        <Link to="/logout" className="btn btn-outline-secondary btn-sm">
                            Logout
                        </Link>
                    </Col>
                ]
            }
        </Row>
    )
}